import React from 'react'
import SvgWrapper from '../SvgWrapper'
import type { IllustrationProps } from './types'

const UmbrellaGuyIllustration: React.FC<IllustrationProps> = ({ width = 150, height = 160 }) => (
  <SvgWrapper height={height} width={width} viewBox="0 0 150 160" fill="none">
    <mask id="a" mask="luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="150" height="160">
      <path d="M.532 0h148.936v160H.532V0Z" fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path d="m54.297-.004-.95.57 50.173 83.752.951-.57L54.297-.003v-.001Z" fill="#020537" fillOpacity=".87" />
      <path d="M68.416 49.475 75 51.642V42.16h-5.975l-.609 7.315Z" fill="#D7B7A8" />
      <path
        d="M74.186 44.785a6.563 6.563 0 0 0 6.562-6.564 6.561 6.561 0 0 0-9.093-6.137 6.564 6.564 0 0 0-4.032 6.137 6.565 6.565 0 0 0 6.563 6.564Z"
        fill="#D7B7A8"
      />
      <path
        d="m72.515 38.736.903 1.097 1.637-2.865s2.089.108 2.089-1.444c0-1.551 1.917-1.593 1.917-1.593s2.712-4.738-2.906-3.488c0 0-3.898-2.671-5.834-.388 0 0-5.942 2.992-4.241 8.204l2.826 5.373.64-1.217s-.388-5.103 2.972-3.682l-.003.003Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path d="M78.186 154.688h5.8v-8.232h-5.8v8.232Z" fill="#D7B7A8" />
      <path
        d="M83.344 159.404c-.992.089-5.956.482-6.205-.656-.227-1.045.108-2.137.155-2.286.476-4.749.654-4.802.762-4.833.169-.049.662.186 1.462.701l.05.034.011.058c.014.075.369 1.818 2.05 1.549 1.152-.183 1.526-.438 1.646-.563a.709.709 0 0 1-.305-.255c-.125-.194-.147-.443-.064-.742.216-.79.864-1.956.892-2.003l.075-.133 6.593 4.449 4.072 1.164a1.049 1.049 0 0 1 .413 1.787c-.74.665-2.208 1.804-3.75 1.945-.41.039-.954.053-1.563.053-2.546 0-6.264-.263-6.291-.269h-.003Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path d="m54.674 142.366 4.602 3.532 5.01-6.531-4.602-3.532-5.01 6.531Z" fill="#D7B7A8" />
      <path
        d="M55.891 149.247c-.842-.532-5.02-3.245-4.523-4.298.454-.967 1.385-1.632 1.515-1.718 3.269-3.477 3.44-3.411 3.546-3.372.166.064.412.549.734 1.446l.02.056-.029.052c-.033.067-.811 1.668.682 2.478 1.025.556 1.476.581 1.648.556a.697.697 0 0 1-.086-.387c.02-.23.153-.441.402-.629.651-.494 1.875-1.026 1.928-1.048l.139-.061 2.523 7.545 2.524 3.403a1.045 1.045 0 0 1 .113 1.061 1.05 1.05 0 0 1-.875.61c-.992.077-2.85.085-4.158-.74-.437-.285-.86-.588-1.272-.909-2.019-1.552-4.809-4.023-4.828-4.043l-.003-.002ZM.532 159.67c0 .183.147.33.33.33h148.277a.33.33 0 0 0 0-.659H.862a.34.34 0 0 0-.126.024.333.333 0 0 0-.204.305Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path
        d="m87.571 87.325-21.9 2.236s-3.128 10.282 1.34 15.2l2.682 13.86-12.067 16.541 7.598 4.919 10.727-11.624v19.67l10.28-.895 4.917-30.847-3.577-29.06Z"
        fill="#2E35A8"
      />
      <path
        d="M77.737 47.982s-1.787-3.128-9.385-2.682l-1.787 4.023s-5.363 1.341-5.363 9.388c0 8.046 2.681 32.188 2.681 32.188l26.148-1.566L77.936 51.52l-.196-3.54-.003.002Z"
        fill="#A5A9DA"
      />
      <path
        d="M51.235 13.145a43.45 43.45 0 0 0 1.202 18.387l28.76-15.148c-.5-.597-1.016-1.18-1.549-1.746A40.446 40.446 0 0 0 64.07 4.436a66.296 66.296 0 0 0-6.745 3.378 76.94 76.94 0 0 0-5.801 3.654 38.542 38.542 0 0 0-.288 1.674l-.001.003Z"
        fill="#FF0080"
      />
      <path
        d="M67.54 4.96a41.259 41.259 0 0 1 9.238 5.846 40.452 40.452 0 0 1 5.17 5.187L100.95 5.985S87.75-5.181 65.182 3.976c.795.303 1.58.632 2.354.986l.004-.002Zm-16.5 24.494a44.42 44.42 0 0 1-.478-17.301c-20.162 14.54-18.24 29.974-18.24 29.974l19.367-10.2c-.238-.817-.46-1.64-.65-2.47l.001-.003Z"
        fill="#FF0080"
      />
      <path
        d="M101.505 76.527c1.709.787 2.665 2.333 2.136 3.455-.529 1.122-2.346 1.394-4.056.61a4.53 4.53 0 0 1-1.75-1.372l-7.2-3.425 1.773-3.452 6.911 3.743a4.618 4.618 0 0 1 2.192.44l-.006.001Z"
        fill="#D7B7A8"
      />
      <path
        d="m97.046 79.05-17.38-5.676-.02-.02-13.239-12.252a5.456 5.456 0 0 1-.706-7.213 5.421 5.421 0 0 1 4.224-2.244 5.421 5.421 0 0 1 4.369 1.95l9.942 11.876 14.32 9.305-1.51 4.274Z"
        fill="#A5A9DA"
      />
    </g>
  </SvgWrapper>
)

export default UmbrellaGuyIllustration
